<!-- <div class="top-bar" #topBar [ngClass]="{'fixed-small': this.fixedbar}">
  <ul #listBar>
    <ng-container *ngFor="let category of tabela; let i = index">
      <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">
        <li class="links" (click)="scrollToSection(i)" #navlink>
          <button><span>{{ category.categoryName }}</span></button>
          <div class="line-list-top-bar" #bar></div>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div> -->

<div class="top-bar" #topBar [ngClass]="{'fixed': this.fixedbar, 'isMobile': this.isMobile, 'isTablet': this.isTablet, 'isDesktop': this.isDesktop}" >
  <ul #listBar>
    <ng-container *ngFor="let category of tabela; let i = index">
      <ng-container *ngIf="(category.products | filtro: filter : 'name').length > 0">
        <li class="links" (click)="scrollToSection(i)" #navlink>
          <button><span>{{ category.categoryName }}</span></button>
          <div class="line-list-top-bar" #bar></div>
        </li>
      </ng-container>
    </ng-container>
  </ul>
</div>

